import { render, staticRenderFns } from "./InvestorPortfolioItem.vue?vue&type=template&id=616d2330&scoped=true&"
import script from "./InvestorPortfolioItem.vue?vue&type=script&lang=js&"
export * from "./InvestorPortfolioItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPortfolioItem.vue?vue&type=style&index=0&id=616d2330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d2330",
  null
  
)

export default component.exports